import { ReactNode } from "react";

import ErrorSection from "@/components/ErrorSection";
import FindBestPriceActionBar from "@/components/FindBestPriceActionBar";
import PageLayout from "../Page";

import styles from "./FindBestPriceResults.module.scss";

interface Props {
  children?: ReactNode;
  showError?: boolean;
}

const FindBestPriceResultLayout: React.FC<Props> = (props: Props) => {
  const { children, showError } = props;
  return (
    <PageLayout>
      <FindBestPriceActionBar />
      {showError ? <ErrorSection /> : <section className={styles.PriceListAndMap}>{children}</section>}
    </PageLayout>
  );
};

export default FindBestPriceResultLayout;
